module.exports = __webpack_public_path__ + "img/nav-03.bdcee74a.jpg";